import { ClientLogger } from 'bernie-client';
import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { getRequestHeaders } from '../common/logging-utils';
import { BexApiSource } from '../sources/bex-api-source';
import { getBexApiSdk } from '../sources/get-bex-api-sdk';
import { ActivityDetailStore } from './activity-detail-store';
import { ActivitySearchStore } from './activity-search-store';
import { DetailCriteriaStore } from './detail-criteria-store';
import { SearchCriteriaStore } from './search-criteria-store';
import { TripCreationStore } from './trip-creation-store';
export { ActivitySearchStore, ActivityDetailStore, DetailCriteriaStore, AdvertisingStore };
export var buildClientSideBexApiSource = function (contextInput) {
  var _a;
  var requestOrContextHeaders = getRequestHeaders(contextInput);
  var url = ((_a = requestOrContextHeaders === null || requestOrContextHeaders === void 0 ? void 0 : requestOrContextHeaders.cookie) === null || _a === void 0 ? void 0 : _a.includes('lxpwastubmode=true')) ? '/things-to-do/graphql' : '/graphql';
  var api = getBexApiSdk(requestOrContextHeaders, url);
  return new BexApiSource(api, ClientLogger.getLoggerWithIdentifier('lx.source.bexapi'));
};
export var stores = {
  activitySearchStore: function (_a) {
    var bexApiContext = _a.bexApiContext;
    return new ActivitySearchStore(buildClientSideBexApiSource(bexApiContext), {}, {}, ClientLogger.getLoggerWithIdentifier('lx.activitySearchStore.bexapi'), {}, bexApiContext);
  },
  searchCriteriaStore: function (_a) {
    var l10n = _a.l10n;
    return new SearchCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.searchCriteria'), l10n);
  },
  activityDetailStore: function (_a) {
    var bexApiContext = _a.bexApiContext;
    return new ActivityDetailStore(buildClientSideBexApiSource(bexApiContext), {}, {}, ClientLogger.getLoggerWithIdentifier('lx.activityDetailStore.bexapi'), {}, bexApiContext);
  },
  detailCriteriaStore: function () {
    return new DetailCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.detailCriteria'));
  },
  advertising: function () {
    return new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.advertising'));
  },
  tripCreationStore: function () {
    return new TripCreationStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.tripCreation'));
  }
};